import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import landingPage from "/styles/jss/bbhost/pages/landingPage.js";
import teamStyle from "/styles/jss/bbhost/pages/landingPageSections/teamStyle.js";
const styles = {
  ...landingPage,
  ...teamStyle,
  main: {
    background: "#f1f5f8",
    position: "relative",
    zIndex: "3",
    paddingTop: "0px",
  }
};

const useStyles = makeStyles(styles);

export default function Message(props) {
  const classes = useStyles();
  return (
    <div className={classes.section} style={{padding: "0"}}>
      <h3 className={classes.title} style={{marginTop: "20px"}}>{props.children}</h3>
    </div>
  );
}